import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'dmmp-four-benefits',
  templateUrl: './four-benefits.component.html',
})

export class FourBenefitsComponent implements OnInit {
  @Input() identifier;
  @Input() data;

  ngOnInit() {
  }
}

